export default "__VITE_ASSET__WVPKpmvq__"